import { render, staticRenderFns } from "./UserViewUserTimelineCard.vue?vue&type=template&id=554e4bcd&"
import script from "./UserViewUserTimelineCard.vue?vue&type=script&lang=js&"
export * from "./UserViewUserTimelineCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports